import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useDataGrid from '@afosto/utils-react/datagrid/useDataGrid';
import DataGrid from '@afosto/app-components-react/DataGrid';
import dataSourceRequest from '@afosto/utils-react/dataSource/dataSourceRequest';
import { subtenants as subtenantsApi } from '@afosto/iam/api/Subtenants';
import { avatarFormatter, pendingActionsFormatter } from './formatters';

const fetchPendingAuthorizationInvites = async dataSource =>
  dataSourceRequest(
    dataSource,
    async (data, requestOptions) => subtenantsApi.listPendingAuthorizationInvites(requestOptions),
    { transformData: data => data },
  );

const PendingAuthorizations = () => {
  const intl = useIntl();
  const dataSource = useDataGrid(fetchPendingAuthorizationInvites, {
    modules: ['dataProperties', 'pagination'],
    dataProperties: {
      fixedProperties: [
        {
          key: 'avatar',
          name: '',
          type: 'avatar',
          width: '50px',
        },
        {
          key: 'email',
          name: intl.formatMessage({
            id: 'dataGrid.columns.pendingAuthorizations.email',
            defaultMessage: 'Email',
            description: 'The column name for column email',
          }),
        },
        {
          key: 'roles',
          name: intl.formatMessage({
            id: 'dataGrid.columns.pendingAuthorizations.roles',
            defaultMessage: 'Roles',
            description: 'The column name for column roles',
          }),
          type: 'translation',
          formatOptions: {
            translationKey: 'roles.{value}',
          },
        },
        {
          key: 'state',
          name: intl.formatMessage({
            id: 'dataGrid.columns.pendingAuthorizations.state',
            defaultMessage: 'State',
            description: 'The column name for column state',
          }),
          type: 'translation',
          formatOptions: {
            translationKey: 'authorizationStates.{value}',
          },
        },
        {
          key: 'created_at',
          name: intl.formatMessage({
            id: 'dataGrid.columns.pendingAuthorizations.invitedAt',
            defaultMessage: 'Invited at',
            description: 'The column name for column requested at',
          }),
          type: 'datetime',
        },
        {
          key: 'actions',
          name: intl.formatMessage({
            id: 'dataGrid.columns.pendingAuthorizations.actions',
            defaultMessage: 'Actions',
            description: 'The column name for column actions',
          }),
          type: 'pendingActions',
          width: '140px',
          align: 'right',
        },
      ],
    },
  });

  return (
    <DataGrid
      dataSource={dataSource}
      formatters={{
        avatar: avatarFormatter,
        pendingActions: pendingActionsFormatter,
      }}
    />
  );
};

export default PendingAuthorizations;
